import React from "react";
import { connect } from "react-redux";
import { removeInfo } from "../../redux/actions/report-actions";

import { createRef } from "react";
import BasePanel from "./base-panel";
import SuccessPanel from "./success-panel";
import ErrorPanel from "./error-panel";

import withLocalization from "../../hoc/with-localization";

import {
    _info_type_success,
    _info_type_error,
    _info_group_SaveData,
    _info_group_ChangeCmpx,
    _info_group_Sign,
    _info_group_SetStimulator
} from "../../redux/actions/actionConstants";

import "./info-panels.scss";

import { CSSTransition, TransitionGroup } from "react-transition-group";

function InfoPanels(props) {
    const onMessageClose = id => {
        const { removeInfo } = props;
        removeInfo(id);
    };

    const { messages, loc } = props;
    const panels = messages.map(_p => {
        const success = _p.type === _info_type_success,
            err = _p.type === _info_type_error;
        const title = success ? loc("messages.successTitle") : err ? loc("messages.errorTitle") : _p.title;

        let text = "";
        if (success) {
            if (_p.group === _info_group_SaveData) text = loc("messages.dataSaved");
            else if (_p.group === _info_group_ChangeCmpx) text = loc("messages.reprCmpxChanged");
            else if (_p.group === _info_group_SetStimulator) text = loc("messages.stimulator_recalced");
            else if (_p.group === _info_group_Sign) text = loc("messages.reportSigned");
        } else if (err) {
            if (_p.group === _info_group_SaveData) text = loc("messages.data_NOT_Saved");
            else if (_p.group === _info_group_ChangeCmpx) text = loc("messages.reprCmpx_NOT_Changed");
            else if (_p.group === _info_group_SetStimulator) text = loc("messages.stimulator_NOT_recalced");
            else if (_p.group === _info_group_Sign) text = loc("messages.report_NOT_Signed");

            const erros = _p.payload;
            if (Array.isArray(erros)) {
                erros.forEach(_e => {
                    if (_e === "Error_MarkupName") text += " " + loc("messages.error.markup");
                    if (_e === "Error_Exception") text += " " + loc("messages.error.unknown");
                    if (_e === "Error_StartProcess" || _e === "Error_Process" || _e === "Error_WaitProcess" || _e === "Error_IncartBoxPath")
                        text += " " + loc("messages.error.requestProcessing");
                    if (_e === "Error_ResultFile") text += " " + loc("messages.error.resultFile");
                    if (_e === "Error_PdfPrinterPath" || _e === "Error_ProtectedPassword") text += " " + loc("messages.error.signature");
                });
            }
        } else text = _p.text;

        const pps = {
            onMessageClose: () => onMessageClose(_p.id),
            title,
            text,
            key: _p.id,
            loc
        };
        return {
            success,
            err,
            pps,
            id: _p.id,
            nodeRef: createRef(null)
        };
    });

    return (
        <TransitionGroup className="info-panels">
            {panels.map(({ id, nodeRef, pps, success, err }) => (
                <CSSTransition key={id} nodeRef={nodeRef} timeout={500} classNames="item">
                    <div ref={nodeRef}>{success ? <SuccessPanel {...pps} /> : err ? <ErrorPanel {...pps} /> : <BasePanel {...pps} />}</div>
                </CSSTransition>
            ))}
        </TransitionGroup>
    );
}

const mapStateToProps = ({
    reportApp: {
        app: {
            infoMessages: { messages }
        }
    }
}) => {
    return {
        messages
    };
};

const mapDispathToProps = {
    removeInfo
};

export default connect(mapStateToProps, mapDispathToProps)(withLocalization(InfoPanels));
